module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "C154"
  }, [_c('em', [_c('a', {
    attrs: {
      "id": "page_ix"
    }
  }, [_vm._v("Contents")])])]), _c('a', {
    attrs: {
      "id": "page_ix"
    }
  }), _c('p', {
    staticClass: "C155"
  }, [_c('a', {
    attrs: {
      "id": "page_ix"
    }
  }, [_c('em')]), _c('em', [_c('a', {
    attrs: {
      "href": "#/html/07_List_of_Figures#page_xi",
      "id": "id_1004"
    }
  }, [_vm._v("List of Figures")])])]), _vm._v(" "), _c('p', {
    staticClass: "C156"
  }, [_c('em', [_c('a', {
    attrs: {
      "href": "#/html/08_List_of_Abbreviations#page_xiii",
      "id": "id_1003"
    }
  }, [_vm._v("List of Abbreviations")])])]), _vm._v(" "), _c('p', {
    staticClass: "C155"
  }, [_c('a', {
    attrs: {
      "href": "#/html/10_Introduction#page_1",
      "id": "id_1002"
    }
  }, [_vm._v("Introduction")])]), _vm._v(" "), _c('p', {
    staticClass: "C155"
  }, [_c('a', {
    attrs: {
      "href": "#/html/11_1__Life_in_the_North__Before_the#page_11",
      "id": "id_996"
    }
  }, [_vm._v("1. Life in the North: Before the War")])]), _vm._v(" "), _c('p', {
    staticClass: "C155"
  }, [_c('a', {
    attrs: {
      "href": "#/html/12_2__A_Grand_Opportunity__1861_and#page_19",
      "id": "id_995"
    }
  }, [_vm._v("2. A Grand Opportunity: 1861 and 1862")])]), _vm._v(" "), _c('p', {
    staticClass: "C155"
  }, [_c('a', {
    attrs: {
      "href": "#/html/13_3__The_Forming_of_Black_Regiment#page_28",
      "id": "id_994"
    }
  }, [_vm._v("3. The Forming of Black Regiments and Success in Battle")])]), _vm._v(" "), _c('p', {
    staticClass: "C155"
  }, [_c('span', {
    attrs: {
      "href": "#/html/14_4__The_Unequal_Pay_Issue#page_44",
      "id": "id_1000",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("4. The Unequal Pay Issue")])]), _vm._v(" "), _c('p', {
    staticClass: "C155"
  }, [_c('span', {
    attrs: {
      "href": "#/html/15_5__Violence_on_Two_Fronts#page_81",
      "id": "id_991",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("5. Violence on Two Fronts")])]), _vm._v(" "), _c('p', {
    staticClass: "C155"
  }, [_c('span', {
    attrs: {
      "href": "#/html/16_6__Information_Requests#page_98",
      "id": "id_990",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("6. Information Requests")])]), _vm._v(" "), _c('p', {
    staticClass: "C155"
  }, [_c('span', {
    attrs: {
      "href": "#/html/17_7__Discharge_Requests#page_120",
      "id": "id_993",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("7. Discharge Requests")])]), _vm._v(" "), _c('p', {
    staticClass: "C155"
  }, [_c('span', {
    attrs: {
      "href": "#/html/18_8__The_Conclusion_of_the_War#page_130",
      "id": "id_999",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("8. The Conclusion of the War")])]), _vm._v(" "), _c('p', {
    staticClass: "C155"
  }, [_c('span', {
    attrs: {
      "href": "#/html/19_9__After_the_War__A_Different_Ki#page_135",
      "id": "id_992",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("9. After the War: A Different Kind of Battle")])]), _vm._v(" "), _c('p', {
    staticClass: "C155"
  }, [_c('span', {
    attrs: {
      "href": "#/html/20_10__Even_Farther_Away_from_Home#page_156",
      "id": "id_998",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("10. Even Farther Away from Home: Occupation Duty Continues")])]), _vm._v(" "), _c('p', {
    staticClass: "C156"
  }, [_c('span', {
    attrs: {
      "href": "#/html/21_11__Home_Again#page_178",
      "id": "id_997",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("11. Home Again")])]), _vm._v(" "), _c('p', {
    staticClass: "C155"
  }, [_c('em', [_c('span', {
    attrs: {
      "href": "#/html/22_Appendix__Northern_Black_Regimen#page_185",
      "id": "id_989",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Appendix: Northern Black Regiments")])])]), _vm._v(" "), _c('p', {
    staticClass: "C155"
  }, [_c('em', [_c('span', {
    attrs: {
      "href": "#/html/23_Acknowledgments#page_187",
      "id": "id_1005",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Acknowledgments")])])]), _vm._v(" "), _c('p', {
    staticClass: "C155"
  }, [_c('em', [_c('span', {
    attrs: {
      "href": "#/html/24_Notes#page_189",
      "id": "id_1006",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Notes")])])]), _vm._v(" "), _c('p', {
    staticClass: "C155"
  }, [_c('em', [_c('span', {
    attrs: {
      "href": "#/html/25_Cited_Literature#page_237",
      "id": "id_1007",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Cited Literature")])])]), _vm._v(" "), _c('p', {
    staticClass: "C155"
  }, [_c('em', [_c('span', {
    attrs: {
      "href": "#/html/26_Index#page_249",
      "id": "id_1001",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Index")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-9a4fcf3e","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/html/06_Contents.vue
// module id = 75
// module chunks = 0